import * as React from "react";
import "./MainComponentStyle.css";


const MainComponent = () => {
  return (
    <>
      <div className="MainDiv">
        <p className="GeneratedDateText">Generated on: [Date]</p>
        <p className="ProjectNameText">Project Name</p>
        <div className="ProjectDetailDiv">
          <p className="ProjectDetalText">Region: [Province]</p>
          <p className="ProjectDetalText">Donor Agency: [XYZ]</p>
          <p className="ProjectDetalText">Executing Agency: [XYZ]</p>
        </div>
        <div className="ProjectSummary">
          <p className="SummaryHeading">Summary:</p>
          <p className="SummaryDetailText">
            [Brief project description extracted and summarized text from the
            PC1 documents. Not more than 5 lines]
          </p>
        </div>
      </div>
    </>
  );
};
export default MainComponent;
